export const tableData1 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
      align:'center'
    },
    {
      key: 'museumname',
      dataIndex: 'museumname',
      title: '博物馆名称',
      align:'center'
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
      align:'center',
      width:'100px'
    },
    {
      key: 'votesum',
      dataIndex: 'votesum',
      title: '票数',
      align:'center'
    },
    {
      key: 'textsum',
      dataIndex: 'textsum',
      title: '文字项个数',
      align:'center'
    },
    {
      key: 'filesum',
      dataIndex: 'filesum',
      title: '附件个数',
      align:'center'
    },
    {
      key: 'referee',
      dataIndex: 'referee',
      title: '推荐人',
      align:'center'
    },
    {
      key: 'name',
      slot: 'operate',
      title: '投票人',
      align:'center'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData2 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
      align:'center'
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '投票人',
      align:'center'
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '第一家博物馆',
      align:'center'
    },
    {
      key: 'score1',
      dataIndex: 'score1',
      title: '得票数',
      align:'center'
    },
    {
      key: 'score2',
      dataIndex: 'score2',
      title: '第二家博物馆',
      align:'center'
    },
    {
      key: 'score3',
      dataIndex: 'score3',
      title: '得票数',
      align:'center'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
